module.exports = __webpack_public_path__ + "img/ui_b_1.9a8f18f9.png";